import React from 'react';
import { siteConfig } from '../data/mock';
import { WhatsAppIcon, TelegramIcon } from './Brand';

const FloatingContact = () => (
  <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[90] flex flex-col items-end gap-3" data-testid="floating-contact">
    <a
      href={`https://t.me/${siteConfig.telegram}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message on Telegram"
      data-testid="floating-telegram-button"
      className="group flex items-center gap-3"
    >
      <span className="px-3 py-1.5 rounded-full bg-white text-ink text-sm font-medium shadow-lg border border-[#E2E8F0] opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 hidden sm:block">
        @{siteConfig.telegram}
      </span>
      <span className="w-14 h-14 rounded-full bg-[#229ED9] text-white flex items-center justify-center shadow-[0_14px_30px_-10px_rgba(34,158,217,0.7)] group-hover:scale-110 group-hover:-rotate-6 transition-transform duration-300">
        <TelegramIcon className="w-6 h-6" />
      </span>
    </a>
    <a
      href={`https://wa.me/${siteConfig.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-button"
      className="group flex items-center gap-3"
    >
      <span className="px-3 py-1.5 rounded-full bg-white text-ink text-sm font-medium shadow-lg border border-[#E2E8F0] opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 hidden sm:block">
        WhatsApp
      </span>
      <span className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_14px_30px_-10px_rgba(37,211,102,0.7)] group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300">
        <span className="absolute inset-0 rounded-full bg-[#25D366] ping-soft opacity-40" />
        <WhatsAppIcon className="relative w-7 h-7" />
      </span>
    </a>
  </div>
);

export default FloatingContact;
